import { Dispatch, SetStateAction } from 'react';

import { useMutation } from '@hooks/reactQuery';

import { getSelectedPresetTree } from '@api/configurationComparison';

import { ITreePreset } from '@interfaces/components/tree';

import { SELECTED_PRESET_TREE } from '@constants/queryKeys';

export const useMutateSelectedPresetTree = (setSavedPreset: Dispatch<SetStateAction<ITreePreset | undefined>>) => {
	const {
		mutate: getPresetTree,
		isLoading: isLoadingSelectedPresetTree,
	} = useMutation<string>({
		mutationKey: [SELECTED_PRESET_TREE],
		mutationFn: getSelectedPresetTree,
		onSuccess: (selectedPresetTree: ITreePreset) => {
			setSavedPreset(selectedPresetTree);
		},
	});

	return { getPresetTree, isLoadingSelectedPresetTree };
};
